import { useCustomer } from '../contexts/CustomerContext';

/**
 * Returns true if the selected customer has force_uppercase_enabled set.
 * Used to convert person name inputs to uppercase while typing.
 */
export function useForceUppercase(): boolean {
  const { selectedCustomer } = useCustomer();
  const c = selectedCustomer as any;
  return !!(c?.condo_data?.force_uppercase_enabled ?? c?.empresa_data?.force_uppercase_enabled ?? false);
}
